module.exports = "p {\n  margin-top: 20vh;\n  line-height: 100px;\n  text-align: center;\n  color: #4285f4;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.css
// module id = ./src/app/components/home/home.component.css
// module chunks = main